import PropTypes from "prop-types";
import { InputNumber } from "./InputNumber";
import { useContext } from "react";
import { TranslationContext } from '../context/TranslationContext';

export const CustomInputNumber = ({
  fieldData,
  label,
  onValueChange,
  value,
  autoSelect = false,
  ...otherProps
}) => {
  const currentValue = value !== undefined ? value : fieldData.default;
  const isDisabled = !fieldData.editable;
  const t = useContext(TranslationContext);
  return (
    <div className="CustomFormGroup">
      <label className={`customLabel ${isDisabled ? "customLabelDisabled" : ""}`}>
        {label}
      </label>
      <div className={`input-wrapper ${isDisabled ? "new-disabled" : ""}`}>
        <InputNumber
          className="custom-input-field"
          value={currentValue}
          onValueChange={onValueChange}
          min={fieldData.min}
          max={fieldData.max}
          disabled={isDisabled}
          autoSelect={autoSelect}
          custompart={true}
          {...otherProps}
        />
        <span className="custom-input-addon">
          {t("config3d_custom_pieces_modal_input_unit")}
        </span>
      </div>
      <div className="max-min-desc">{!isDisabled && <><span>Min : {fieldData.min} </span><span>Max : {fieldData.max}</span></>}</div>
    </div>
  );
};

CustomInputNumber.propTypes = {
  // Field configuration from JSON
  fieldData: PropTypes.shape({
    default: PropTypes.number,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    editable: PropTypes.bool,
    id: PropTypes.string.isRequired,
    impact: PropTypes.number.isRequired
  }).isRequired,

  // Label for the input (e.g., "width", "depth", "height1", etc.)
  label: PropTypes.string.isRequired,

  // Callback when value changes
  onValueChange: PropTypes.func.isRequired,

  // Current value (can be different from default if modified)
  value: PropTypes.number,

  // Additional props for InputNumber
  autoSelect: PropTypes.bool
};

export default CustomInputNumber;